define((require) => {
    "use strict";

    const ChannelSetupManualView            = require("ui/publish/channelSetup/ChannelSetupManualView");
    const ProjectAttachChannelSetupItemView = require("ui/projects/publish/ProjectAttachChannelSetupItemView");

    /**
     * Subclass of ChannelSetupManualView representing the attach lightbox Channel in a project context. <p>
     *
     * @class ProjectAttachChannelSetupManualView
     * @see ChannelSetupManualView
     * @see ProjectDashboardChannelSetupItemView
     */
    return ChannelSetupManualView.extend("ProjectAttachChannelSetupManualView", {

        initialize() {
            this.collectionViewOptions = {
                itemView: ProjectAttachChannelSetupItemView
            };

            this.__super();
        },

        options: {
            showDropTarget: false
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/projects/publish/ProjectAttachChannelSetupManualView.js